import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from 'react-router-dom';
import decryptCookieData from "./Functions/decryptCookieData";

const offers = [
    "🔥 Login now and get 10% OFF!",
    "🎁 Signup today and win rewards!",
    "🚀 Limited time offer on electronics!",
];

const navLinks = [
    { label: "Home", path: "/" },
    { label: "Products", path: "/products" },       // ✅ Newly added
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
];


const Header = ({ cartItemsLength, cartButtons }) => {
    const [index, setIndex] = useState(0);
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [cartCount, setCartCount] = useState(3);
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userName, setUserName] = useState("User");
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null; // Decrypt cookie data
   
    const [products, setProducts] = useState([])
    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const url = process.env.REACT_APP_API_URL
    const [profile, setProfile] = useState({})
    const [marquee, setMarquee] = useState([])
    const [user, setUser] = useState(null);


    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));
        setUser(storedUser);
    }, []);


    const handleNavigation = (path) => {
        if (path === "/admission-form") {
            localStorage.removeItem("checkout_data");
        }
        if (path === "/course") {
            localStorage.removeItem("admission");
        }

        navigate(path);
        setDrawerOpen(false); // Close drawer after navigation
    };


    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${process.env.REACT_APP_PERFUME_ID}`, {
                method: "GET"
            })
            const res = await response.json();
            setProducts(res);
        } catch (error) {
            console.log(error)
        }
    }

    const handleSearchChange = (value) => {
        setSearchTerm(value);
        if (!value.trim()) {
            setSuggestions([]);
            return;
        }

        const filtered = products
            .filter(p => p.title.toLowerCase().includes(value.toLowerCase()))
            .map(p => p.title); // or return the full product if needed

        const unique = [...new Set(filtered)].slice(0, 8); // Limit suggestions
        setSuggestions(unique);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % offers.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    const handleSuggestionClick = (text) => {
        setSearchTerm(text);
        setSuggestions([]);
        navigate(`/product?search=${encodeURIComponent(text)}`);
    };

    const fetchUserData = async () => {
        try {
            const profileRes = await fetch(`${url}/register/single/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await profileRes.json();
            const profileData = res.users
            setProfile(profileData)
        } catch (error) {
            console.log(error)
        }
    }

    const fetchMarquee = async () => {
        try {
            const response = await fetch(`${url}/marquee/all/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            setMarquee(res);
        } catch (error) {
            console.log(error)
        }
    }

    const getDefaultCartButton = () => {
        if (!Array.isArray(cartButtons)) return null;

        const isGetQuoteDefault = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        if (isGetQuoteDefault) return 'getquote';

        const isAddToCartDefault = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        if (isAddToCartDefault) return 'addtocart';

        const isBuyNowDefault = cartButtons.find(b => b.button_id === 'buynow' && b.default);
        if (isBuyNowDefault) return 'buynow';

        return null;
    };


    const defaultButton = getDefaultCartButton();
    useEffect(() => {
        fetchProducts();
        fetchUserData();
        fetchMarquee();
    }, [])
    return (
        <>
            <header className="header">
                {/* 1st Row: Animated Offers */}
                {Array.isArray(marquee) && marquee.length > 0 && (
                    <div className="header-top marquee-container">
                        <div className="marquee-content">
                            {marquee.map((ele, idx) => (
                                <span key={idx} style={{ marginRight: "60px" }}>
                                    {ele.heading}
                                </span>
                            ))}
                        </div>
                    </div>
                )}



                {/* 2nd Row: Logo - Search - Icons */}
                <div className="header-middle online-india-header-middle">
                    <div className="logo" onClick={() => navigate("/")}>{profile?.profilePic ? (
                        <img
                            src={`${url}/uploads/profile/${profile.profilePic}`}
                            alt="Logo"
                        />
                    ) : (
                        <div className="logo-text-prefume">
                            <div className="logo-text-perfume-main">
                                {profile?.orignal_logoname || ""}
                            </div>
                            <div className="logo-text-perfume-tagline">
                                <p>{profile?.tag_line || ""}</p>
                            </div>
                        </div>
                    )}
                    </div>
                    <div className="search-box">
                        <input type="text" className="search-input" placeholder="Search for products..."
                            value={searchTerm}
                            onChange={(e) => handleSearchChange(e.target.value)}
                        />
                        <i className="fas fa-search search-icon"></i>
                        {suggestions.length > 0 && (
                            <ul className="suggestions-dropdown">
                                {suggestions.map((s, index) => (
                                    <li key={index} onClick={() => handleSuggestionClick(s)}>
                                        <i className="fas fa-search"></i> {s}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>


                    <div className="icons">
                        {
                            defaultButton === "getquote" ? null : <div className="cart-container-header" onClick={() => navigate("/cart")}>
                                <i className="fas fa-shopping-cart"></i>
                                {cartItemsLength > 0 && <span className="cart-badge-header">{cartItemsLength}</span>}
                            </div>
                        }

                        {userData ? (
                            <div className="user-info" onClick={() => navigate("/my-account")}>
                                <i className="fas fa-user-circle"></i>
                                <span>Hello, {userData?.full_name}</span>
                            </div>
                        ) : (
                            <div className="user-info" onClick={() => navigate("/login")}>
                                <i className="fas fa-user-circle" ></i>
                                <span>Login/Register</span>
                            </div>
                        )}

                    </div>
                </div>

                {/* 3rd Row: Navigation */}
                <nav className="header-nav">
                    <ul>
                        {navLinks.map((link, i) => (
                            <li key={i} onClick={() => handleNavigation(link.path)}>
                                {link.label}
                            </li>
                        ))}
                    </ul>
                </nav>

            </header>



            <header className="header-mobile">
                {/* 1st Row: Animated Offers */}
                {Array.isArray(marquee) && marquee.length > 0 && (
                    <div className="header-top marquee-container">
                        <div className="marquee-content">
                            {marquee.map((ele, idx) => (
                                <span key={idx} style={{ marginRight: "60px" }}>
                                    {ele.heading}
                                </span>
                            ))}
                        </div>
                    </div>
                )}


                {/* 2nd Row: Logo & Icons */}
                <div className="header-middle">

                    <div className="logo" onClick={() => navigate("/")}>{profile?.profilePic ? (
                        <img
                            src={`${url}/uploads/profile/${profile.profilePic}`}
                            alt="Logo"
                            style={{ height: "40px", objectFit: "contain" }}
                        />
                    ) : (
                        <div className="logo-text-prefume">
                            <div className="logo-text-perfume-main">
                                {profile?.orignal_logoname || ""}
                            </div>
                            <div className="logo-text-perfume-tagline">
                                <p>{profile?.tagline || ""}</p>
                            </div>
                        </div>
                    )}
                    </div>
                    <div className="icons">
                        {
                            defaultButton === "getquote" ? null : <div className="cart-container-header" onClick={() => navigate("/cart")}>
                                <i className="fas fa-shopping-cart"></i>
                                {cartItemsLength > 0 && <span className="cart-badge-header">{cartItemsLength}</span>}
                            </div>
                        }

                        {userData ? (
                            <div className="user-info" onClick={() => navigate("/my-account")}>
                                <i className="fas fa-user-circle"></i>
                            </div>
                        ) : (
                            <div className="user-info" onClick={() => navigate("/login")}>
                                <i className="fas fa-user-circle" ></i>
                            </div>
                        )}
                        <i className="fas fa-bars" onClick={() => setDrawerOpen(true)}></i>
                    </div>
                </div>

                {/* 3rd Row: Full Width Search Bar */}
                <div className="search-box">
                    <input type="text" className="search-input"
                        value={searchTerm}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        placeholder="Search for products..." />
                    <i className="fas fa-search search-icon"></i>
                    {suggestions.length > 0 && (
                        <ul className="suggestions-dropdown">
                            {suggestions.map((s, index) => (
                                <li key={index} onClick={() => handleSuggestionClick(s)}>
                                    <i className="fas fa-search"></i> {s}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Bard's Drawer (Side Navigation) */}
                <div className={`drawer ${isDrawerOpen ? "open" : ""}`}>
                    <button className="close-btn" onClick={() => setDrawerOpen(false)}>✖</button>
                    <ul>
                        {navLinks.map((link, i) => (
                            <li key={i} onClick={() => handleNavigation(link.path)}>
                                {link.label}
                            </li>
                        ))}
                    </ul>



                </div>


            </header>
        </>
    );
};

export default Header;
